import { MurfInputLabel } from "@/components/elements/MurfInputLabel";
import OutlinedTextField from "@/components/elements/OutlinedTextField";
import { useAppDispatch, useTypedSelector } from "@/config/configureAppStore";
import {
  CREATE_PROJECT_COMPACT_VIEW_WIDTH,
  PROJECT_FLOW_TYPES,
  PROJECT_NAME_MAX_LENGTH
} from "@/features/createProject/constants";
import useCreateProject from "@/features/createProject/hooks/useCreateProject";
import { setProjectName } from "@/reducers/slices/clientProjectPopupSlice/clientProjectPopupSlice";
import { EditRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  outlinedInputClasses,
  Stack,
  Typography
} from "@mui/material";
import React, { useState } from "react";

export const AddProjectName = (): React.ReactNode => {
  const dispatch = useAppDispatch();
  const { currentFlowType } = useCreateProject();
  const [isEditingName, setIsEditingName] = useState(
    currentFlowType !== PROJECT_FLOW_TYPES.NON_ICP_NEW
  );
  const projectName = useTypedSelector(
    (state) => state.clientProjectPopup.projectName
  );

  if (isEditingName) {
    return (
      <Box sx={{ width: 452, maxWidth: "calc(50% - 24px)" }}>
        <OutlinedTextField
          id="project-name"
          label="Project Name"
          placeholder="My Awesome Project"
          fullWidth
          size="small"
          value={projectName}
          onChange={(e) => {
            if (e.target.value?.length > PROJECT_NAME_MAX_LENGTH) {
              return;
            }
            dispatch(setProjectName(e.target.value));
          }}
          sx={(theme) => ({
            [`& .${outlinedInputClasses.root}`]: {
              backgroundColor: "background.default"
            },
            [theme.breakpoints.down(CREATE_PROJECT_COMPACT_VIEW_WIDTH)]: {
              [`& .${outlinedInputClasses.root}`]: {
                minHeight: 40
              }
            },
            [theme.breakpoints.up(CREATE_PROJECT_COMPACT_VIEW_WIDTH)]: {
              [`& .${outlinedInputClasses.root}`]: {
                minHeight: 56
              }
            }
          })}
        />
      </Box>
    );
  }

  return (
    <Stack>
      <Stack direction={"row"} alignItems={"center"}>
        <MurfInputLabel sx={{ flexShrink: 0 }}>Project Name</MurfInputLabel>
        <Button
          startIcon={<EditRounded />}
          variant="text"
          size="small"
          color="secondary"
          onClick={() => {
            setIsEditingName(true);
          }}
          sx={{
            ml: 1
          }}
          id="edit-project-name"
        >
          Edit
        </Button>
      </Stack>
      <Typography variant="body1" color="text.primary">
        {projectName}
      </Typography>
    </Stack>
  );
};
